import React, { useCallback, useRef, useState } from "react";
import { Button, Field, Form } from "@bwevents/components";
import { Link as LinkExternal } from "@bwevents/components";
import { Checkbox } from "primereact/checkbox";
import "./AdditionalInfo.scss";
import { useLocation } from "react-router-dom";

const getTopicsSelecteds = (topics) => {
  const topicIds = [];
  topics.forEach((topic) => {
    if (topic.check) topicIds.push(topic.id);
  });
  return topicIds;
};

export default function AdditionalInfo({
  api,
  account,
  messenger,
  setAccount,
  layout = "page",
  canEditState = false,
}) {
  const { pathname } = useLocation();

  let topics = useRef([...account.topics]);
  const topicsListed = account.topics.filter((topic) => topic.check);

  const [loading, setLoading] = useState(false);
  const [canEdit, setCanEdit] = useState(
    canEditState ||
      (!account.topics.some((topic) => topic.check) &&
        !account.other_interests),
  );
  const [limitTopics, setLimitTopics] = useState(3);
  const [limitInterest, setLimitInterest] = useState(3);

  const [form, setForm] = useState({
    country: account.country || "",
    company: account.company || "",
    job_title: account.job_title || "",
    topics: topics.current.length ? getTopicsSelecteds(topics.current) : [],
    other_interests: account.other_interests || "",
  });

  const formValid =
    form.country || form.company || form.job || form.topics.length;
  const interests =
    account.other_interests && account.other_interests.length
      ? account.other_interests.split(",")
      : [];

  const onSubmit = () => {
    setLoading(true);

    api(`api/providers/${process.env.REACT_APP_SLUG}/users/my_profile/`, {
      method: "PATCH",
      body: form,
      ignoreError: true
    }).then(({ ok }) => {
      if (ok) {
        const topicsListed = topics.current.map((topic) => {
          if (form.topics.includes(topic.id)) {
            topic.check = true;
          }
          return topic;
        });

        setAccount({ ...account, ...form, topics: topicsListed });
        messenger({
          severity: "success",
          detail: "Updated additional information.",
          life: 3000,
        });
      } 

      setLoading(false);
    });
  };

  const onCategoryChange = useCallback(({ checked, value }) => {
    let updatedTopics = [];

    topics.current = topics.current.map((topic) => {
      if (topic.id === value) topic.check = checked;
      return topic;
    });

    if (!checked) {
      updatedTopics = form.topics.filter((topicId) => topicId !== value);
    } else {
      updatedTopics = [...form.topics, value];
    }

    setForm((prev) => ({ ...prev, topics: updatedTopics }));
  }, [form, topics, setForm]);

  const resetForm = () => {
    setForm({
      country: account.country || "",
      company: account.company || "",
      job_title: account.job_title || "",
      topics: account.topics ? getTopicsSelecteds([...account.topics]) : [],
      other_interests: account.other_interests || "",
    });
  };

  return (
    <div className="additional-info">
      {pathname === "/profile" ? (
        <>
          <h2>We aim to be interesting</h2>
          <p>
            With a more comprehensive profile, we will suggest more tailored
            recommendations based on your preferences.
          </p>
        </>
      ) : null}
      <Form>
        {canEdit ? (
          <Field
            type="text"
            label="Country"
            placeholder="Your country"
            value={form?.country}
            setValue={(country) => setForm((prev) => ({ ...prev, country }))}
            className="bw-event-input"
          />
        ) : (
          <div className="additional-info-wrapper-edit">  
            <h3 className="bw-input-label"> Country </h3>
            <strong> {form?.country} </strong>
          </div>
        )}
        {canEdit ? (
          <Field
            type="text"
            label="Company"
            placeholder="Your company name"
            value={form?.company}
            setValue={(company) => setForm((prev) => ({ ...prev, company }))}
            className="bw-event-input"
          />
        ) : (
          <div className="additional-info-wrapper-edit">  
            <h3 className="bw-input-label"> Company </h3>
            <strong> {form?.company} </strong>
          </div>
        )}
        {canEdit ? (
          <Field
            type="text"
            label="Job title"
            placeholder="Start typing here..."
            value={form?.job_title}
            setValue={(job_title) => setForm((prev) => ({ ...prev, job_title }))}
            className="bw-event-input"
            disabled={!canEdit}
          />
        ) : (
          <div className="additional-info-wrapper-edit">  
            <h3 className="bw-input-label"> Job title </h3>
            <strong> {form?.job_title} </strong>
          </div>
        )}

        <div
          className={`bw-event-wrapper-topics ${!canEdit ? "additional-info-wrapper-edit" : ""}`}
        >
          <h3 className="bw-input-label">Interest topics</h3>
          <div className="wrapper-checkbox">
            {canEdit ? (
              topics.current.map((topic, key) => (
                <div
                  key={key}
                  className="item-checkbox flex align-items-center"
                >
                  <Checkbox
                    className="bw-event-checkbox"
                    inputId={key}
                    name="topic"
                    value={topic.id}
                    onChange={onCategoryChange}
                    checked={topic.check}
                  />
                  <label htmlFor={key} className="bw-event-checkbox-label">
                    {topic.name}
                  </label>
                </div>
              ))
            ) : (
              <div className="interests">
                {topicsListed.length && form.topics.length ? (
                  <>
                    {topicsListed && topicsListed.length
                      ? topicsListed
                          .slice(0, limitInterest)
                          .map((item, key) => (
                            <span key={key + "-" + item.name}>
                              {item.check ? (
                                <p className="bw-event-btn-tag">{item.name}</p>
                              ) : null}
                            </span>
                          ))
                      : null}

                    {topicsListed && limitInterest < topicsListed.length ? (
                      <button
                        className="bw-event-btn-more-limit"
                        onClick={() => setLimitInterest(topicsListed.length)}
                      >
                        +{topicsListed.length - limitInterest} more
                      </button>
                    ) : null}
                  </>
                ) : (
                  <p> Not items found </p>
                )}
              </div>
            )}
          </div>
        </div>

        <div className={`bw-event-wrapper-interests ${!canEdit ? "additional-info-wrapper-edit" : ""}`}>
          <h3 className="bw-input-label">Interest topics</h3>
          {canEdit ? (
            <>
              <Field
                type="text"
                placeholder="Want to Explore other content? Add it here"
                value={form?.other_interests}
                setValue={(other_interests) =>
                  setForm((prev) => ({ ...prev, other_interests }))
                }
                className="bw-event-input"
              />
              <span className="bw-event-callout m-0">
                Example: hybrid events, sponsorship, logistics
              </span>
            </>
          ) : (
            <div className="interests">
              {account.other_interests && account.other_interests.length ? (
                <>
                  {interests && interests.length
                    ? interests.slice(0, limitTopics).map((item, key) => (
                        <p className="bw-event-btn-tag" key={key + item}>
                          {" "}
                          {item}{" "}
                        </p>
                      ))
                    : null}

                  {interests && limitTopics < interests.length ? (
                    <button
                      className="bw-event-btn-more-limit"
                      onClick={() => setLimitTopics(interests.length)}
                    >
                      +{interests.length - limitTopics} more
                    </button>
                  ) : null}
                </>
              ) : (
                <p> Not items found </p>
              )}
            </div>
          )}
        </div>

        <p className="terms">
          We’re respect your privacy. Review our{" "}
          <LinkExternal href="https://bweventstech.com/privacy-and-terms/">
            Privacy Policy
          </LinkExternal>{" "}
          to be sure your information is completely safe
        </p>

        <div className="wrapper-btns">
          {layout !== "modal" ? (
            <>
              {!canEdit ? (
                <Button
                  className="bw-event-btn-can-edit"
                  label="Edit info"
                  onClick={() => setCanEdit(true)}
                />
              ) : (
                <>
                  {formValid ? (
                    <Button
                      className="bw-event-btn cancel"
                      label="Cancel"
                      onClick={() => {
                        setCanEdit(false);
                        resetForm();
                      }}
                    />
                  ) : null}
                  <Button
                    className="bw-event-btn"
                    label="Save info"
                    disabled={!formValid}
                    onClick={onSubmit}
                    loading={loading}
                  />
                </>
              )}
            </>
          ) : (
            <Button
              className="bw-event-btn"
              label="Submit"
              disabled={!formValid}
              onClick={onSubmit}
              loading={loading}
            />
          )}
        </div>
      </Form>
    </div>
  );
}
